export class Maps {

    constructor ( google, target = '.js-map', options = {} ) {

        this.google = google;
        this.target = target;

        this.options = {
            mapTypeControl: true,
            zoomControlOptions: { style: this.google.maps.ZoomControlStyle.DEFAULT },
            overviewMapControl: true,
            scaleControl: true,
            mapTypeControlOptions: {
                mapTypeIds: [  ]
            },
            ...options
        };
    }

    init () {
        this.containers = Array.from( document.querySelectorAll( this.target ) );

        this.containers.forEach( container => {
            const lat = container.getAttribute( 'data-lat' );
            const lng = container.getAttribute( 'data-lng' );
            const address = container.getAttribute( 'data-address' );

            this.map = new this.google.maps.Map( container, {
                center: new this.google.maps.LatLng( lat, lng ),
                zoom: 15,
                mapTypeId: this.google.maps.MapTypeId.ROADMAP,
                scrollwheel: false,
            } );


            this.map.setOptions( this.options );

            this.marker = new this.google.maps.Marker( {
                                                      animation: this.google.maps.Animation.DROP,
                                                      position: this.map.getCenter(),
                                                      map: this.map,
                                                      draggable: false,
                                                      optimized: false,
                                                  } );
            this.info = new this.google.maps.InfoWindow( { content: address } );
        } )


    }
}